import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, model } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'qwiko-dashboard-side-nav',
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './dashboard-side-nav.component.html',
  styleUrl: './dashboard-side-nav.component.scss',
})
export class DashboardSideNavComponent {
  sideNavIsOpen = model<boolean>(true);
}
